"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _differenceInDays = _interopRequireDefault(require("date-fns/differenceInDays"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Function to check if drop off time is > T + 30 (from curr time)
 * If dropoff date is today
 * @param {string} pickupTime in 12 hrs format
 * @param {number} leadTime in minutes
 * @returns {boolean}
 */
function isDropOffValid(pickupDate, dropOffDate, minimumDays) {
  var diff = (0, _differenceInDays["default"])(dropOffDate, pickupDate);
  return diff >= minimumDays;
}
var _default = exports["default"] = isDropOffValid;